"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegenerativeLoopAbilityHandler = exports.RegenerativeLoopActorAbilityFactory = exports.RegenerativeLoopAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const AttributeBasedHealing_1 = require("../../core/effects/core/AttributeBasedHealing");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
class RegenerativeLoopAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.RegenerativeLoop;
        this.__typeName = "RegenerativeLoop";
    }
}
exports.RegenerativeLoopAbilityArgs = RegenerativeLoopAbilityArgs;
let RegenerativeLoopActorAbilityFactory = class RegenerativeLoopActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("RegenerativeLoop", "Self", 5);
    }
};
RegenerativeLoopActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("RegenerativeLoop")
], RegenerativeLoopActorAbilityFactory);
exports.RegenerativeLoopActorAbilityFactory = RegenerativeLoopActorAbilityFactory;
let RegenerativeLoopAbilityHandler = class RegenerativeLoopAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyBuff({
            sequence,
            creatorId: ability.invokerId,
            targetId: ability.invokerId,
            effect: new AttributeBasedHealing_1.AttributeBasedHealingEffectArgs("RegenerativeLoop", AttributeType_1.AttributeType.Health, 5),
            duration: Duration_1.Duration.Turns(4),
        });
    }
};
RegenerativeLoopAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.RegenerativeLoop)
], RegenerativeLoopAbilityHandler);
exports.RegenerativeLoopAbilityHandler = RegenerativeLoopAbilityHandler;
